// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"06922a6b","471":"06922a6b"}[chunkId] + ".chunk.css";
};